<template>
  <transition name="plus-icon">
    <div class="modelBox" v-if="data.isShow">
      <div class="model">
        <div class="head">
          <p>{{ data.name }}</p>
        </div>
        <div class="content">
          <h4>{{ data.title }}</h4>
          <div>
            <p>
              {{ data.desc1 }}
            </p>
            <p>
              {{ data.desc2 }}
            </p>
            <p>
              {{ data.desc3 }}
            </p>
          </div>
        </div>
        <div
          class="btn hvr-shutter-out-horizontal"
          @click="hidemodel({ isShow: false })"
        >
          <p>关闭</p>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
export default {
  computed: {
    ...mapGetters({
      data: "getdata"
    })
  },
  methods: {
    ...mapMutations(["hidemodel"])
  }
};
</script>

<style lang="less" scoped>
.plus-icon-enter-active {
  transition: opacity 0.5s;
}
.plus-icon-enter {
  opacity: 0;
}
.plus-icon-leave-active {
  transition: opacity 0.5s;
}
.plus-icon-leave-to {
  opacity: 0;
}
.plus-icon-enter-to {
  opacity: 1;
}
.hvr-shutter-out-horizontal:before {
  background: rgba(255, 125, 51, 1);
}
.modelBox {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 11111115;
  background: rgba(0, 0, 0, 0.6);
  .model {
    position: fixed;
    width: 5.88rem;
    height: 6.55rem;
    background: rgba(255, 255, 255, 1);
    background-image: url("../images/niao.png");
    background-position: 0% 80%;
    background-size: 3.62rem 2.69rem;
    background-repeat: no-repeat;
    border-radius: 0.15rem;
    top: 50%;
    left: 50%;
    margin-left: -2.94rem;
    margin-top: -3.475rem;
    .head {
      width: 2.78rem;
      height: 0.91rem;
      background: url("../images/btn.png");
      background-size: 100% 100%;
      position: absolute;
      top: -0.45rem;
      left: 50%;
      margin-left: -1.39rem;
      p {
        font-size: 0.361rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.91rem;
      }
    }
    .content {
      width: 5.3rem;
      margin: 0.6rem auto 0;
      height: 4.4rem;
      overflow: auto;
      h4 {
        margin-top: 0.16rem;
        font-size: 0.28rem;
        font-family: PingFang SC;
        font-weight: 500;
        color: #333333;
        text-align: center;
      }
      p {
        font-size: 0.26rem;
        color: rgba(51, 51, 51, 1);
        margin-top: 0.4rem;
        line-height: 0.4rem;
      }
    }
    .btn {
      width: 4.65rem;
      height: 0.91rem;
      transform: scale(0.7);
      background: rgba(255, 125, 51, 1);
      border-radius: 0.46rem;
      position: absolute;
      bottom: 0.35rem;
      left: 50%;
      margin-left: -2.325rem;
      p {
        font-size: 0.4rem;
        color: rgba(255, 255, 255, 1);
        text-align: center;
        line-height: 0.91rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/h5/model.vue